// extracted by mini-css-extract-plugin
export default {"fab":"AssistantHost_fab__jP83O","fabLogo":"AssistantHost_fabLogo__LoSmL"};